import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

/* Sprite-backed: menus and breadcrumbs repeat it per row; see `IconSprite`. */
export const ChevronRight = (props: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.chevronRight}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    />
  );
};

export default ChevronRight;
